// Filename - pages/termosdeuso.js

import React from "react";
import Rodape from "../rodape.js";
import { Header } from "../header.js";
import './not_found.css';

const NotFound = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

	return (
    <>
        <Header isMobile={isMobile}/>
        <div className="base-not-found">
        <h1>Página não encontrada (404)</h1>
        <p>A página que você tentou acessar não foi encontrada no nosso site.</p>
        <p>Possíveis motivos para isto:</p>
        <ul>
            <li>A página não existe mais</li>
            <li>A página nunca existiu</li>
            <li>O endereço foi digitado incorretamente</li>
        </ul>
        <p>Qualquer que seja o caso, fique à vontade para conhecer o nosso site e aprender circuitos elétricos conosco.</p>
        <span><a href="/">Ir para página inicial do site</a></span>
        <p>Explore também os menus no cabeçalho na parte superior do site (desktop) ou através do botão de menu no canto superior direito (mobile).</p>
        </div>
        <Rodape />
    </>
	);
};

export default NotFound;